const config = {
  pagination: false,
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '优惠类型',
      dataIndex: 'merchTypeName',
      width: 100,
    },
    {
      title: '优惠小类',
      dataIndex: 'discountSubcategoryName',
      width: 100,
    },
    {
      title: '状态',
      dataIndex: 'flowStateName',
      width: 100,
    },
    {
      title: '申请比例/个数',
      dataIndex: 'applyInfo',
      width: 100,
    },
    {
      title: '申请时间',
      width: 160,
      dataIndex: 'createdTime',
      itemType:'dateTime',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 160,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '申请人',
      dataIndex: 'createdByName',
      width: 160,
    },
  ],
  search: [
  ]
}

export default config
